// @flow
import React from 'react';
import { Visitor } from '@ta/lithium.context';
import ProfileSectionNarrowLogout from './ProfileSectionNarrowLogout';

/**
 * Checks logged in status to determine what content to show.
 * Currently shows a CTA on logged out state, and nothing when logged in.
 */
const ProfileNarrowContainer = () => {
  const { userId } = React.useContext(Visitor);

  if (userId === '' || userId == null) {
    return <ProfileSectionNarrowLogout />;
  }

  return null;
};

export default ProfileNarrowContainer;
